module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/assessment_achievements/2_cc4b2b43dd757a3e8f113999fc26df2c.png";